<div class="loggedout-page" fxLayout="column">
    <div class="logged-out-message" fxLayout="column">
        <img height="150px" src="assets/liquitics-logo.svg" />
        <h3>You are logged out</h3>
        <a href="/">Log back in</a>
    </div>

</div>